export default {
  imageLoading: 'https://content.autotrader.com/content/dam/autotrader/shared/img/InventoryImage-NoImage-Placeholder_350x282.jpg',
  noImageAvailable: 'https://content.autotrader.com/content/dam/autotrader/ui/no-image-available.svg'
};